/**
 * Publications and public artifacts. Statuses are honest: nothing is called
 * "published" unless it is actually public today.
 */

export interface Publication {
  slug: string;
  title: string;
  venue: string;
  year: number;
  status: 'public-artifact' | 'preprint-in-preparation' | 'in-preparation';
  statusLabel: string;
  summary: string;
  href?: string;
}

export const publications: Publication[] = [
  {
    slug: 'anu-runtime',
    title: 'Agent Native Universe — an open runtime for self-organizing agents',
    venue: 'Open-source release (MIT)',
    year: 2026,
    status: 'public-artifact',
    statusLabel: 'Public artifact',
    summary:
      'Versioned MIT-licensed release of the agent-native runtime: relationship negotiation, resource economy, byzantine agreement, recursive organization. The code is the publication.',
    href: 'https://github.com/StudyLabPro/agent-native-universe',
  },
  {
    slug: 'uwt-preprint',
    title: 'Unified Wholeness Theory — preprint package',
    venue: 'arXiv (in preparation)',
    year: 2026,
    status: 'preprint-in-preparation',
    statusLabel: 'Preprint in preparation',
    summary:
      'The theoretical track prepared for open publication: registered experiments, automated tests over claims, and a reproducible preprint package.',
    href: 'https://uwt.xteam.pro',
  },
  {
    slug: 'balansis-library',
    title: 'Balansis — an open library for computation that survives singularities',
    venue: 'Open-source release (AGPL-3.0) · PyPI',
    year: 2026,
    status: 'public-artifact',
    statusLabel: 'Public artifact',
    summary:
      'The laboratory’s numerical foundation, released as a library rather than as a note: division by zero, overflow and precision loss are handled explicitly in the API instead of deferred to edge-case logic. Source on GitHub, releases on PyPI — the code is the publication.',
    href: 'https://github.com/StudyLabPro/Balansis',
  },
];

export const publicationBySlug = new Map(publications.map((p) => [p.slug, p]));
